/**
 * Utility functions for dashboard widgets
 */

/**
 * Check if a widget item exists and has a valid value (not null)
 * @param {Object} widget - The widget object
 * @param {string} itemKey - The item key to check (e.g., '$w1', '$w2', '$w3')
 * @returns {boolean} True if the item exists and has a valid value
 */
export const hasValidWidgetItem = (widget, itemKey) => {
  return (
    widget.items?.[itemKey] &&
    widget.items[itemKey].value &&
    widget.items[itemKey].value !== "null"
  );
};
